module.exports = __webpack_public_path__ + "static/media/logo-canal-rural.2f56704b.png";